/**
 * Offerings module configuration
 * ───────────────────────────────
 * All offering-specific labels, status config, and form defaults live here.
 * Change OFFERING_LABEL to rename the feature everywhere in this module.
 */
import { ENTITIES } from '../../constants/labels';
import { PLEDGE_STATUS } from '../../constants/statusMaps';
import { today } from '../../utils/dateUtils';

// ── Change this to rename "Offering" everywhere in this module ──────────────
export const OFFERING_LABEL = ENTITIES.pledge;

// Re-export so module internals can import from one place
export { PLEDGE_STATUS as STATUS_CONFIG };

export const newItem = () => ({
  id: Date.now() + Math.random(),
  donationCategoryId: '', categoryName: '', qty: '', rate: '', amount: '',
});

export const EMPTY_FORM = {
  userId: '', userName: '', userEmail: '',
  financialYearId: '',
  offeringDate: today(),
  isEventDay: false,
  notes: '',
  items: [],
};
